window.assignmentReactionCurriculumVitaeFormatter = function(value, row) {
    let html = '';
    html += '<a href="/mijn-opdrachten/reacties/curriculum-vitae/'+row.assignment_reaction_id+'" target="_blank">';
    html += '<i class="fal fa-id-card"></i>';
    html += '</a>';
    return html;
};
